export default {
    state: {},
    getters: {},
    mutations: {},
    actions: {
        getSeoData() {
            return new Promise((resolve, reject) => {
                window.axios.get("/admin/setting/seo/all")
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        },
        updateSeoData(_, data) {
            return new Promise((resolve, reject) => {
                window.axios.post("/admin/setting/seo/update", data)
                    .then((res) => {
                        resolve(res.data)
                    })
                    .catch((err) => {
                        reject(err)
                    })
            })
        }
    },
}

